import { useCallback } from "react";
import { VideoPlatform } from "../video-sdk";
import { useIsZoomEnabled } from "./useIsZoomEnabled";

function getVideoPlatform(isZoomEnabled: boolean): VideoPlatform {
  return isZoomEnabled ? VideoPlatform.Zoom : VideoPlatform.Twilio;
}

export function useVideoPlatform(): [VideoPlatform, () => VideoPlatform] {
  const [isZoomEnabled, checkIsZoomEnabled] = useIsZoomEnabled();
  const videoPlatform = getVideoPlatform(isZoomEnabled);

  const getVideoPlatformCallback = useCallback(
    () => getVideoPlatform(checkIsZoomEnabled()),
    [checkIsZoomEnabled],
  );

  return [videoPlatform, getVideoPlatformCallback];
}
